'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function BlockShow(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M960 480h-64V160a32 32 0 0 0-32-32H160a32 32 0 0 0-32 32v704a32 32 0 0 0 32 32h192v64H127.712C92.512 960 64 931.2 64 896.288V127.68C64 92.512 92.8 64 127.712 64H896.32C931.488 64 960 92.8 960 127.712V480zM288 160h64v64H288V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m0 128h64v64h-64V288zM160 288h64v64H160V288z m0 128h64v64H160v-64z m0 128h64v64H160v-64z m0 128h64v64H160v-64zM160 160h64v64H160V160z m0 640h64v64H160v-64z' }),
    React.createElement('path', { d: 'M672 956c-181.728 0-256.512-152.256-275.968-198.88a57.472 57.472 0 0 1 0-42.24c19.456-46.624 94.24-198.88 275.968-198.88 180.896 0 256.512 152.256 275.968 198.88 5.376 13.76 5.376 28.48 0 42.24-19.456 46.624-95.072 198.88-275.968 198.88z m0-120A100.32 100.32 0 0 0 772 736 100.32 100.32 0 0 0 672 636 100.32 100.32 0 0 0 572 736 100.32 100.32 0 0 0 672 836z m0-160A60.16 60.16 0 0 1 732 736 59.936 59.936 0 0 1 672 796 59.936 59.936 0 0 1 612 736 60.16 60.16 0 0 1 672 676z' })
  );
}
BlockShow.displayName = 'BlockShow';

module.exports = BlockShow;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/blockShow.js
// module id = 155
// module chunks = 0